import React from 'react';
import {Typography} from 'lark';
import './index.less';

const loginSuccess = require('@/public/assets/qrcode/成功.png');
const loginSuccess2x = require('@/public/assets/qrcode/成功@2x.png');
const loginSuccess3x = require('@/public/assets/qrcode/成功@3x.png');

const {Paragraph} = Typography;

const QRLoginSuccess = () =>
    (
        <div className="qr-success">
            <div className="qr-success-img-wrapper">
                <img
                    className="qr-success-img"
                    srcSet={`${loginSuccess}, ${loginSuccess2x} 2x, ${loginSuccess3x} 3x,`}
                    src={loginSuccess3x}
                    alt="成功"
                />
            </div>
            <Paragraph>登录成功</Paragraph>
        </div>
    );
export default QRLoginSuccess;
